import React from "react";
import { FaWhatsapp } from "react-icons/fa";

const WhatsAppChat = () => {
    return (
        <a
            href="https://wa.me/917600668600?text=Hello%20👋%20I%20want%20to%20to%20enquire%20about%20tour%20packages"
            target="_blank"
            rel="noopener noreferrer"
            className="whatsapp-chat"
            aria-label="Chat on WhatsApp"
        >
            <FaWhatsapp />
        </a>
    );
};

export default WhatsAppChat;
